if (!customElements.get("sb-collection-list")) {
  class SBCollectionList extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.init = this.init.bind(this);
      this.destroy = this.destroy.bind(this);
      this.enableSlider = this.dataset.enableSlider === "true" || false;
      this.columns = this.dataset.columns || 3.5;
      this.cardStyle = this.dataset.cardStyle || "style-1";
      this.autoRotate = this.dataset.autoRotate === "true" || false;
      this.autoRotateSpeed = this.dataset.autoRotateSpeed || 5;
    }

    connectedCallback() {
      if (!this.enableSlider) return;
      if (window.Swiper) {
        this.init();
      } else {
        const interval = setInterval(() => {
          if (window.Swiper) {
            clearInterval(interval);
            this.init();
          }
        }, 50);
      }
    }

    disconnectedCallback() {
      if (!this.enableSlider) return;
      this.destroy();
    }

    init() {
      const swiperContainer = this.closest(".swiper");
      if (!swiperContainer || swiperContainer.classList.contains("swiper-initialized")) return;

      const slides = this.querySelectorAll(".swiper-slide");
      // Defensive: only init if >1 slides
      if (slides.length <= 1) return;

      const slideGapParsed = Number.parseInt(this.dataset.slideGap, 10);
      const gap = Number.isFinite(slideGapParsed) && slideGapParsed >= 0 ? slideGapParsed : 5;

      const columns = Number.parseFloat(this.dataset.columns);
      if (Number.isFinite(columns)) {
        this.slidesPerView = columns + 0.5;
      }

      const columnsMobileParsed = Number.parseFloat(this.dataset.columnsMobile);
      const columnsMobile = Number.isFinite(columnsMobileParsed) && columnsMobileParsed > 0 ? columnsMobileParsed : 1.5;

      let breakpoints;
      if (this.cardStyle === "style-3") {
        breakpoints = {
          360: {
            slidesPerView: columnsMobile,
            spaceBetween: gap,
          },
          750: {
            slidesPerView: 3.2,
            spaceBetween: gap,
          },
          1024: {
            slidesPerView: 4.5,
            spaceBetween: gap,
          },
          1200: {
            slidesPerView: this.slidesPerView,
            spaceBetween: gap,
          },
        };
      } else if (this.cardStyle === "style-4") {
        this.slidesPerView = this.dataset.columns;
        breakpoints = {
          360: {
            slidesPerView: columnsMobile,
            spaceBetween: gap,
          },
          750: {
            slidesPerView: 4,
            spaceBetween: gap,
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: gap,
          },
          1200: {
            slidesPerView: this.slidesPerView,
            spaceBetween: gap,
          },
        };
      } else {
        breakpoints = {
          360: {
            slidesPerView: columnsMobile,
            spaceBetween: gap,
          },
          750: {
            slidesPerView: 2.5,
            spaceBetween: gap,
          },
          1200: {
            slidesPerView: this.slidesPerView,
            spaceBetween: gap,
          },
        };
      }

      const root = this.closest(".sb-collection-list");

      // Configure Swiper options
      const swiperOptions = {
        slidesPerView: columnsMobile,
        spaceBetween: gap,
        breakpoints: breakpoints,
        watchOverflow: false,
        grabCursor: false,
        loop: false,
        navigation: {
          nextEl: (root || swiperContainer).querySelector(".custom-next"),
          prevEl: (root || swiperContainer).querySelector(".custom-prev"),
        },
      };

      if (this.cardStyle === "style-3" && this.autoRotate) {
        swiperOptions.autoplay = {
          delay: 0,
          disableOnInteraction: false,
        };
        swiperOptions.speed = this.autoRotateSpeed * 1000;
        swiperOptions.loop = true;
        swiperOptions.freeMode = {
          enabled: true,
          momentum: false,
        };
      }

      this.swiper = new window.Swiper(swiperContainer, swiperOptions);

      swiperContainer.classList.add("swiper-initialized");
      if (root) root.classList.add("is-carousel-initialized");
    }

    destroy() {
      if (this.swiper && this.swiper.destroy) {
        this.swiper.destroy();
        this.swiper = null;
        const swiperContainer = this.closest(".swiper");
        if (swiperContainer) {
          swiperContainer.classList.remove("swiper-initialized");
        }
        const root = this.closest(".sb-collection-list");
        if (root) root.classList.remove("is-carousel-initialized");
      }
    }
  }

  customElements.define("sb-collection-list", SBCollectionList);
}
